import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { StationsState } from '../../types';

import { getStationsPriceReport } from '../operations/getStationsPriceReport';

import { STATUS_LOADING } from 'common/constants';

export const setStationsPriceReport = (builder: ActionReducerMapBuilder<StationsState>) => builder
  .addCase(getStationsPriceReport.pending, (state) => {
    state.stationsPriceReport.loadingStatus = STATUS_LOADING.load;
  })
  .addCase(getStationsPriceReport.fulfilled, (state, { payload }) => {
    state.stationsPriceReport.loadingStatus = STATUS_LOADING.done;
    state.stationsPriceReport.data = payload;
  })
  .addCase(getStationsPriceReport.rejected, (state) => {
    state.stationsPriceReport.loadingStatus = STATUS_LOADING.error;
  });
